const INITIAL_STATE = {
  lightsOn: false,
  spaceOn: false,
  darkMode: true,
};

const rootReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'GOT_LOCAL_STORAGE_THEME':
      return {
        ...state,
        ...action.payload, // same as writing out 'lightsOn: action.payload.lightsOn, spaceOn: action.payload.spaceOn'
      };
    case "TOGGLE_LIGHTS":
      return {
        ...state,
        lightsOn: action.payload,
      };
    case "TOGGLE_SPACE":
      return {
        ...state,
        spaceOn: action.payload,
      };
    case "TOGGLE_DARK_MODE":
      return {
        ...state,
        darkMode: action.payload,
      };
    default:
      return state;
  }
}

export default rootReducer;
